import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import ImageContainer from "@components/imageContainer";
import {
  ButtonContainer,
  DidYouKnowAddonDesc,
  DidYouKnowAddonHeading,
  DidYouKnowAddonWrapper
} from "./styles";
import DOMPurify from "isomorphic-dompurify";
import PrimaryButtonContainer from "@widgets/PrimaryButton";
import { useContext } from "react";
import { Context } from "@components/useContext/context";
import { useOnload } from "@utils/useOnLoad";

const DidYouKnowAddon = ({ children, ...props }) => {
  const {
    src,
    heading,
    benefits,
    ctaLabel,
    ctaDescription,
    description,
    actions
  } = props || {};

  const { isDesktop } = useContext(Context);

  const { on_load } = actions || {};

  useOnload({ on_load });

  return (
    <Box>
      <DidYouKnowAddonWrapper width="auto">
        <ImageContainer imgSrc={src} width={isDesktop ? 88 : 80} height={isDesktop ? 88 : 80} />
        <DidYouKnowAddonHeading>{heading}</DidYouKnowAddonHeading>
        <DidYouKnowAddonDesc
          style={{ marginTop: "16px" }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description)
          }}
        />
        {benefits?.map((item) => (
          <Flex margin="16px 0px 0px 0px">
            <img src={item?.src} width={24} height={24} />
            <DidYouKnowAddonDesc style={{ marginLeft: "12px" }}>
              {item?.text}
            </DidYouKnowAddonDesc>
          </Flex>
        ))}
      </DidYouKnowAddonWrapper>

      <ButtonContainer>
        <DidYouKnowAddonDesc
          style={{ marginTop: "0px" }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(ctaDescription)
          }}
        />
        <PrimaryButtonContainer
          actions={actions}
          label={ctaLabel}
          isFullWidth
          labelStyles={{ fontSize: "16px", fontWeight: 600 }}
        />
      </ButtonContainer>
    </Box>
  );
};

export default DidYouKnowAddon;
